import React from 'react';
import { Table, Tag, Space, Select, DatePicker, Input } from 'antd';

const { Option } = Select;
const { RangePicker } = DatePicker;

const mockPayments = [
    { key: '1', tenant: 'Acme Corp', amount: 49, date: '2024-07-01', method: 'Credit Card', status: 'Paid' },
    { key: '2', tenant: 'Beta Ltd', amount: 99, date: '2024-06-25', method: 'PayPal', status: 'Failed' },
    { key: '3', tenant: 'Gamma Inc', amount: 999, date: '2024-06-20', method: 'Bank Transfer', status: 'Paid' },
];

const PaymentHistory = () => {
    const columns = [
        { title: 'Tenant', dataIndex: 'tenant', key: 'tenant' },
        { title: 'Amount', dataIndex: 'amount', key: 'amount', render: (v) => `$${v}` },
        { title: 'Date', dataIndex: 'date', key: 'date' },
        { title: 'Method', dataIndex: 'method', key: 'method' },
        { title: 'Status', dataIndex: 'status', key: 'status', render: (status) => <Tag color={status === 'Paid' ? 'green' : 'red'}>{status}</Tag> },
    ];
    return (
        <>
            <Space style={{ marginBottom: 16 }}>
                <Input.Search placeholder="Search by tenant" style={{ width: 200 }} />
                <Select placeholder="Method" style={{ width: 120 }} allowClear>
                    <Option value="Credit Card">Credit Card</Option>
                    <Option value="PayPal">PayPal</Option>
                    <Option value="Bank Transfer">Bank Transfer</Option>
                </Select>
                <Select placeholder="Status" style={{ width: 120 }} allowClear>
                    <Option value="Paid">Paid</Option>
                    <Option value="Failed">Failed</Option>
                </Select>
                <RangePicker />
            </Space>
            <Table columns={columns} dataSource={mockPayments} />
        </>
    );
};
export default PaymentHistory; 